import React, { useEffect, useState } from 'react';
import { updateUserOptions } from '../api/movies';
import { Button } from './Button';
import { Flex } from './Flex';
import { Input } from './Input';
import { Popover } from './Popover';

export function UserOptionsModal({ isOpen, onClose, userData, onSuccess }) {
  const [displayName, setDisplayName] = useState('');
  const [countryCode, setCountryCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (userData?.options) {
      setDisplayName(userData.options.display_name || '');
      setCountryCode(userData.options.country_code || '');
    }
  }, [userData, isOpen]);

  const handleSave = async () => {
    setError('');
    setLoading(true);
    try {
      const updatedOptions = {
        display_name: displayName,
        country_code: countryCode,
      };
      await updateUserOptions(updatedOptions);
      if (onSuccess) {
        onSuccess(updatedOptions);
      }
      onClose();
    } catch (err) {
      setError(err.message || 'Failed to save options');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Popover open={isOpen} onClose={onClose} modal={true} showBackdrop={true}>
      <div className="user-options-modal">
        <h2>Edit Profile</h2>

        <div className="user-options-modal__form">
          <Input
            label="Display Name"
            value={displayName}
            onChange={(e) => setDisplayName(e.target.value)}
            placeholder="Enter your display name"
          />
          <Input
            label="Country Code"
            value={countryCode}
            onChange={(e) => setCountryCode(e.target.value)}
            placeholder="e.g., US, UK, FR"
          />
          {error && <div className="user-options-modal__error">{error}</div>}
        </div>

        <Flex
          direction="row"
          gap="1rem"
          justify="flex-end"
          className="user-options-modal__actions"
        >
          <Button variant="secondary" onClick={onClose} disabled={loading}>
            Cancel
          </Button>
          <Button onClick={handleSave} disabled={loading}>
            {loading ? 'Saving...' : 'Save'}
          </Button>
        </Flex>
      </div>
    </Popover>
  );
}
